export default "__VITE_ASSET__D9X60ypR__"